export default __webpack_public_path__ + "static/media/linkedin.91d4e814.png";